import {
  Box,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Textarea,
  Heading,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";
import UuidPreview from "../../UuidPreview";
import { createEmptyClause } from "../../utils/placementDefaults";

const ClauseEditor = ({ clause, clauseIndex, onUpdate, onRemove }) => {
  const updateField = (field, value) => {
    onUpdate(clauseIndex, field, value);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} mb={4} borderColor="gray.300">
      <UuidPreview uuid={clause.id} />

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
        <FormControl>
          <FormLabel>Code</FormLabel>
          <Input
            value={clause.code || ""}
            onChange={(e) => updateField("code", e.target.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel>Description</FormLabel>
          <Input
            value={clause.description || ""}
            onChange={(e) => updateField("description", e.target.value)}
          />
        </FormControl>
      </SimpleGrid>

      <FormControl mb={4}>
        <FormLabel>Text</FormLabel>
        <Textarea
          value={clause.text || ""}
          onChange={(e) => updateField("text", e.target.value)}
          rows={4}
        />
      </FormControl>

      <HStack justify="flex-end">
        <IconButton
          size="sm"
          icon={<HiOutlineTrash />}
          aria-label="Delete Clause"
          onClick={() => onRemove(clauseIndex)}
        />
      </HStack>
    </Box>
  );
};

const ClausesEditor = ({ clauses = [], onChange }) => {
  const updateClause = (clauseIndex, field, value) => {
    const updated = [...clauses];
    updated[clauseIndex] = {
      ...updated[clauseIndex],
      [field]: value,
    };
    onChange(updated);
  };

  const addClause = () => {
    onChange([...clauses, createEmptyClause()]);
  };

  const removeClause = (clauseIndex) => {
    const updated = [...clauses];
    updated.splice(clauseIndex, 1);
    onChange(updated);
  };

  return (
    <Box>
      <HStack alignItems="center" mb={4}>
        <Heading size="md">Clauses</Heading>
        <IconButton
          icon={<HiOutlinePlus />}
          size="md"
          aria-label="Add Clause"
          onClick={addClause}
        />
      </HStack>

      {clauses.map((clause, clauseIndex) => (
        <ClauseEditor
          key={clause.id}
          clause={clause}
          clauseIndex={clauseIndex}
          onUpdate={updateClause}
          onRemove={removeClause}
        />
      ))}
    </Box>
  );
};

export default ClausesEditor;
